import React from 'react';

const industryData = [
  { label: "Total Industry Revenue", value: "$1365.4 Millions" },
  { label: "Industry Participants", value: "330 Businesses" },
  { label: "Avg Revenue per Business", value: "$4,137,575.76" },
  { label: "Average Employees", value: "6.1" },
  { label: "Industry Revenue Volatility", value: "Moderate" },
  { label: "Growth Industry Revenue (12 mths)", value: "2.60%", trend: "up" }, // Trend added
  { label: "Employment Cost Growth", value: "0.60%", trend: "down" },  // Trend added
  { label: "Average Employee Wages", value: "$94,981.89" },
  { label: "Business Concentration Level", value: "Low" },
  { label: "Industry Capital Intensity", value: "Low" },
  { label: "Industry Life Cycle Stage", value: "Decline" },
  { label: "Technology Change", value: "High" },
  { label: "Barriers to Entry", value: "High" },
];

const IndustryOverview = () => {
  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">Cables R Us</h2>
      <div className="row">
        {industryData.map((data, index) => (
          <div key={index} className="col-md-4 mb-4">
            <div className="card shadow-lg rounded">
              <div className="card-body">
                <h5 className="card-title mb-3">{data.label}</h5>
                <p className="card-text">
                  {data.value}
                  {data.trend === "up" && (
                    <span className="text-success ms-2">
                      <i className="bi bi-arrow-up-circle" /> {data.trend}
                    </span>
                  )}
                  {data.trend === "down" && (
                    <span className="text-danger ms-2">
                      <i className="bi bi-arrow-down-circle" /> {data.trend}
                    </span>
                  )}
                  {data.trend === "neutral" && (
                    <span className="text-muted ms-2">
                      <i className="bi bi-arrow-right-circle" /> {data.trend}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IndustryOverview;
